import { Select, Dropdown, Tooltip, Modal } from "antd";
import $ from "jquery";
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import SessionManager from "../../routes/SessionManager";
import Loading from '../Loading';
import camera_icon from './../../assets/img/camera.svg';
import Toastr from 'toastr';
import ZoneCard from "../dashboard/ZoneCard";
import ZoneHistoryCarousel from "../zone-history/ZoneHistoryCarousel";
import CommonUtils from "../../util/CommonUtils";
import LiveCameraFeed from "../modals/LiveCameraFeed";
import AxisLiveCameraFeed from "../modals/AxisLiveCameraFeed";
import API from '../../service/SiteKickAPIService';

const { Option } = Select;
let viewer = {};
let cameras = {}
const BIMViewer = () => {
    let sessionManager = new SessionManager();
    let user1 = sessionManager.readCookie('user');
    let bim_model = user1.bim_selected;
    let bim_markers_permission = CommonUtils.hasPermission('SITESUPT-UI-BIM-MARKERS-MODIFY');
    let bim_streaming_permission = CommonUtils.hasPermission('SITESUPT-UI-VIEW-STREAMING');

    let zones = getActiveZones();
    const [user, setUser] = useState(user1);
    const [cameras_original, setCamerasOriginal] = useState({});
    // const [cameras, setCameras] = useState({});
    const [loading, setLoading] = useState(true);
    const [enableCancelButton, setEnableCancelButton] = useState(false);
    const [bim_model_details, setBimModelDetails] = useState(null);
    const [plans, setPlans] = useState(null);
    const [levels, setLevels] = useState(null);
    const [bim_bundles, setBimBundles] = useState(null);
    const [showZoneHistory, setShowZoneHistory] = useState(false);
    const [turnOnVideoStreaming, setTurnOnVideoStreaming] = useState(false);
    const [enableSaveButton, setEnableSaveButton] = useState(false);
    const [refresh_timestamp, setRefreshTimestamp] = useState(new Date().getTime());

    let timezone = user.site_selected.site_iana_timezone;
    if (!timezone)
        timezone = moment.tz.guess();


    function fetchCustomerDetails() {
        let criteria = { "from": 0, "size": 1, customer_id: user.customer_id };
        CommonUtils.ajax(
            {
                url: API.COMMON_TABLE_OPERATIONS.CUSTOMER.FETCH,
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify({
                    source: 'D',
                    criteria: criteria,
                    "user_type": "user",
                    user_login: user.user_login,
                    user_token: user.user_token,
                    app_name: 'SITESUPT'
                })
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    if (res.data.records.length > 0) {
                        let user = sessionManager.readCookie('user');
                        user.customer = res.data.records[0];
                        sessionManager.storeCookie('user', user);
                        setUser(user);
                    }
                }
            },
            (res) => {

            });
    }

    useEffect(() => {
        // var loadScript = function (src) {
        //     var tag = document.createElement('script');
        //     tag.async = false;
        //     tag.src = src;
        //     var body = document.getElementsByTagName('body')[0];
        //     body.appendChild(tag);
        // }
        // loadScript('bim.js');
        if (user.customer_id && !user.customer) {
            fetchCustomerDetails();
        }
        fetchBIMModelDetails();
        fetchBIMMarkers();
        document.body.style.overflow = 'hidden';
    }, []);

    let fetchBIMModelDetails = () => {
        let query = 'project_id=' + bim_model.project_id + '&view=mobile&filters[has_revisions]=true&sort=title&filters[id]=[' + bim_model.id + ']';
        CommonUtils.ajax(
            {
                url: API.BASE_URL_BIM + '/bim_models?' + query,
                type: 'GET',
                contentType: "application/json; charset=utf-8",
                dataType: "json"
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    setBimModelDetails(res.data[0]);
                    // console.log(res.data[0]);
                }
            },
            (res) => {

            });

    }

    useEffect(() => {
        if (bim_model_details !== null) {
            fetchBIMPlans();
        }
    }, [bim_model_details]);

    let fetchBIMPlans = () => {
        let query = 'bim_models?project_id=' + bim_model.project_id + '&view=mobile';
        $.ajaxSetup({
            url: API.BASE_URL_BIM + '/bim_models',
            global: false,
        });
        CommonUtils.ajax(
            {
                url: API.BASE_URL_BIM + '/' + query,
                type: 'GET',
                contentType: "application/json; charset=utf-8",
                dataType: "json"
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    let data = res.data;
                    let plans = [];
                    let bim_level_ids = [];
                    for (let k of data) {
                        let levels = k.current_revision.bim_levels;
                        if (levels !== undefined && levels !== null)
                            plans = plans.concat(levels);
                    }

                    for (let p of plans) {
                        bim_level_ids.push(p.id);
                    }
                    //console.log('plans', plans);
                    //console.log('bim_level_ids', bim_level_ids);
                    setPlans(plans);
                    fetchBIMLevels(bim_level_ids);
                }
            },
            (res) => {

            });
    }

    let fetchBIMLevels = (bim_level_ids) => {
        //console.log("fetchBIMLevels")
        let query = 'bim_levels?project_id=' + bim_model.project_id + '&view=extended&filters[id]=[' + bim_level_ids + ']';
        CommonUtils.ajax(
            {
                url: API.BASE_URL_BIM + '/' + query,
                type: 'GET',
                contentType: "application/json; charset=utf-8",
                dataType: "json"
            }
        ).then(
            (res) => {
                //console.log("fetchBIMLevels: ", res)
                if (res.status && res.status.code === 200) {
                    // console.log(res.data);
                    setLevels(res.data);
                }
            },
            (res) => {

            });
    }

    useEffect(() => {
        if (levels !== null) {
            fetchBIMBundles();
        }
    }, [levels]);

    let fetchBIMBundles = () => {
        if (!CommonUtils.hasPath(bim_model_details, 'current_revision.geometry_file_bundle_id')) {
            setLoading(false);
            setBimBundles({});
            Toastr.error("BIM Model has no valid bundles in current revision.")
            return
        }
        let query = 'bim_geometry_file_bundles/' + bim_model_details.current_revision.geometry_file_bundle_id + '?project_id=' + bim_model.project_id + '&view=extended';
        CommonUtils.ajax(
            {
                url: API.BASE_URL_BIM + '/' + query,
                type: 'GET',
                contentType: "application/json; charset=utf-8",
                dataType: "json"
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    setBimBundles(res.data);
                }
            },
            (res) => {

            });
    }

    useEffect(() => {
        if (bim_bundles !== null && Object.keys(bim_bundles).length > 0) {
            loadBIMModels();
        }
    }, [bim_bundles]);

    let loadBIMModels = () => {
        //console.log(bim_model_details.current_revision);
        let viewPoints = bim_model_details.current_revision.viewpoints;
        // console.log(viewPoints);

        let bcfCamera = {};
        if (viewPoints.length > 0)
            bcfCamera = JSON.parse(viewPoints[0].camera_data);

        let bundle = bim_bundles;
        let view = new window.ProcoreBim.Webviewer({
            bcfCamera: bcfCamera,
            version: 1,
            parentElement: document.getElementById('procore-bim-main'),
            projectId: bim_model.project_id,
            companyId: user.procore_user.company_id,
            modelId: bim_model.id,
            modelRevisionId: bim_model.current_revision_id,
            swScope: '/app/',
            swEnable: true,
            ...bim_model_details,
            cellUrl: bundle.cell_file.url,
            meshUrl: bundle.mesh_file.url,
            meshnodeUrl: bundle.mesh_node_file.url,
            nodeUrl: bundle.node_file.url,
            tools: [
                window.ProcoreBim.Webviewer.tools.CONTEXTMENU,
                window.ProcoreBim.Webviewer.tools.BOTTOMTOOL,
                window.ProcoreBim.Webviewer.tools.COACHMARKS,
                window.ProcoreBim.Webviewer.tools.MEASUREMENT_SD,
                window.ProcoreBim.Webviewer.tools.SETTINGS,
                window.ProcoreBim.Webviewer.tools.VIEW_PROPERTIES,
                window.ProcoreBim.Webviewer.tools.OBJECTMODELTREE,
                window.ProcoreBim.Webviewer.tools.FLOORPLAN
            ],
            plans: plans,
            levels: levels
        });
        view.start();

        viewer = view

        window.ProcoreBim.Cache.hasModel({
            cellUrl: bundle.cell_file.url,
            meshUrl: bundle.mesh_file.url,
            meshnodeUrl: bundle.mesh_node_file.url,
            nodeUrl: bundle.node_file.url,
            project_id: bim_model.project_id
        }).then(function (isCached) {

            document.ondblclick = bim_markers_permission ? function (e) {
                let camera = { ...cameras };
                for (let k of Object.keys(cameras)) {
                    if (camera[k]['location_id'] === '00000') {
                        delete camera[k];
                        cameras = camera;
                        // setCameras(camera);
                        // console.log('removing marker: ' + k);
                        $('#' + k).remove()
                    }
                }
                let camera_locator = {
                    location_id: '00000',
                    offsetX: (e.offsetX / $('#procore-bim-main-canvas').width()), offsetY: (e.offsetY / $('#procore-bim-main-canvas').height())
                };

                if (viewer.camera.getBcfCamera().then && typeof viewer.camera.getBcfCamera().then === 'function') {
                    viewer.camera.getBcfCamera().then(x => {
                        camera_locator.bcfCamera = { perspective_camera: { ...x.perspective_camera } };
                        createMarker(camera_locator, 'N');
                    });
                } else {
                    Toastr.info("BIM Viewer edit mode not supported on this device.")
                }

            } : () => { };

            viewer.events.addEventListener('cameraUpdated', (v) => {
                if (viewer.camera.getBcfCamera().then && typeof viewer.camera.getBcfCamera().then === 'function') {
                    viewer.camera.getBcfCamera().then(x => {
                        // current_screen_position = x;
                        //console.log('cameraUpdated - bcfcamera', x);
                        //console.log('camera keys', Object.keys(cameras));

                        for (let k of Object.keys(cameras)) {
                            let cam_pos = cameras[k];
                            createMarker(cam_pos);
                        }

                    });
                }
            });

            viewer.events.addEventListener('renderReady', (v) => {
                setLoading(false);
            });

        });
    }

    // let getCameraPosKey = (cam_pos) => {
    //     let b2 = cam_pos.bcfCamera.perspective_camera.camera_view_point;
    //     let pos = [
    //         parseInt(b2.x),
    //         parseInt(b2.y),
    //         parseInt(b2.z)
    //     ];
    //     return (pos.join('-')) + "O" + cam_pos.location_id;
    // }

    let createMarker = (cam_pos, editMode) => {
        //console.log('cam_pos', cam_pos);
        viewer.camera.getBcfCamera().then(x => {
            let b1 = x.perspective_camera.camera_view_point;
            let b2 = cam_pos.bcfCamera.perspective_camera.camera_view_point;

            let pos = [
                parseInt(b2.x),
                parseInt(b2.y),
                parseInt(b2.z)
            ];

            let k = (pos.join('-')) + "O" + cam_pos.location_id;
            let camera = { ...cameras };
            if (editMode === 'N') {
                camera[k] = cam_pos;
                //console.log('this.cameras after adding new camera', this.cameras);
                cameras = camera;
                // setCameras(camera);
            }
            let d = $('#' + k);
            if ((b1.x - b2.x >= 0 && b1.x - b2.x <= 20 && b1.y - b2.y >= 0 && b1.y - b2.y <= 20) || ['N', 'F'].includes(editMode)) {

                if ($(d).length === 0) {
                    d = document.createElement('div');
                    d.id = k;
                    d.className = "marker"

                    let content = [];
                    content.push('<img class="surv-camera" src=' + camera_icon + ' width="50px" height="50px" />')
                    content.push('<div id="' + k + '-rem_location_picker"></div>');

                    d.innerHTML = content.join('');


                    let location = cam_pos.location_id ? zones.find(location => location.location_id === cam_pos.location_id) : null;
                    if (editMode !== 'N' && location == null)
                        return;
                    document.getElementById('procore-bim-main').appendChild(d);
                    let enable_view_streaming = user && user.site_selected && (user.site_selected.site_view_streaming === undefined ? true : user.site_selected.site_view_streaming);
                    let items = [
                        {
                            key: '0',
                            label: <span onClick={() => streamVideo(location)}><i className="fas fa-video"></i> View Streaming</span>
                        },
                        {
                            key: '1',
                            label: <span onClick={() => fetchZoneHistory(location)}><i className="fas fa-history"></i> Zone History</span>
                        },
                        {
                            key: '2',
                            label: <span onClick={() => deleteMarker(k, location)}><i className="cursor-pointer far fa-trash-alt fa-fw text-danger"></i> Delete Marker</span>
                        }
                    ]
                    if ((!bim_streaming_permission || enable_view_streaming === false) || (location && location.location_operstatus === "Disconnected")) {
                        items.shift();
                    }
                    if (!bim_markers_permission) {
                        items.pop();
                    }
                    let select = <Dropdown menu={{ items }}>
                        <div >
                            <Tooltip placement="left" overlayInnerStyle={{ width: '250px', padding: '0', backgroundColor: 'transparent', boxShadow: 'none', color: '#333333' }} autoAdjustOverflow={false} title={<ZoneCard do_not_navigate={true} zone={location} site={user.site_selected}></ZoneCard>}>
                                <span className="cursor-pointer bg-warning font-size-12 p-1 border-rounded">{location ? location.location_name : ""}</span>
                            </Tooltip>
                        </div>
                    </Dropdown>;

                    let cameras_inuse = Object.values(cameras).map(c => c.location_id);
                    let cameras_filtered = zones.filter(location => !cameras_inuse.includes(location.location_id));

                    //console.log('cameras_inuse, cameras_filtered', [cameras_inuse, cameras_filtered]);

                    if (editMode === 'N' && cameras_filtered.length === 0) {
                        Toastr.error("All the gateways are already marked.");
                        return;
                    }



                    if (editMode === 'N') {
                        select = <Select name="location_id" onChange={(obj) => onCameraGatewayChange(obj, k, camera)} style={{ width: '100%' }} placeholder="Choose Gateway location">
                            {cameras_filtered.map(c => <Option key={c.location_id} value={c.location_id}>{c.location_name}</Option>)}
                        </Select>
                        setEnableCancelButton(true);
                    }

                    ReactDOM.render(select, ReactDOM.findDOMNode(document.getElementById(k + "-rem_location_picker")));


                }

                $(d).removeClass("hide");
                $(d).attr('style', 'position: absolute; left:' + (cam_pos.offsetX * $('#procore-bim-main-canvas').width()) + 'px; top:' + (cam_pos.offsetY * $('#procore-bim-main-canvas').height()) + 'px;');
            } else {
                if ($(d))
                    $(d).addClass("hide");
            }
        });
    }

    let showMarker = (cam_pos, editMode) => {
        let b2 = cam_pos.bcfCamera.perspective_camera.camera_view_point;

        let pos = [
            parseInt(b2.x),
            parseInt(b2.y),
            parseInt(b2.z)
        ];

        let k = (pos.join('-')) + "O" + cam_pos.location_id;
        let camera = { ...cameras };
        if (editMode === 'N') {
            camera[k] = cam_pos;
            cameras = camera;
            // setCameras(camera);
            //console.log('this.cameras after adding new camera', this.cameras);
        }
        let d = $('#' + k);

        if ($(d).length === 0) {
            d = document.createElement('div');
            d.id = k;
            d.className = "marker"

            let content = [];
            content.push('<img class="surv-camera" src=' + camera_icon + ' width="50px" height="50px" />')
            content.push('<div id="' + k + '-rem_location_picker"></div>');

            d.innerHTML = content.join('');


            let location = cam_pos.location_id ? zones.find(location => location.location_id === cam_pos.location_id) : null;
            if (editMode !== 'N' && location == null)
                return;
            document.getElementById('procore-bim-main').appendChild(d);
            let enable_view_streaming = user && user.site_selected && (user.site_selected.site_view_streaming === undefined ? true : user.site_selected.site_view_streaming);
            let items = [
                {
                    key: '0',
                    label: <span onClick={() => streamVideo(location)}><i className="fas fa-video"></i> View Streaming</span>
                },
                {
                    key: '1',
                    label: <span onClick={() => fetchZoneHistory(location)}><i className="fas fa-history"></i> Zone History</span>
                },
                {
                    key: '2',
                    label: <span onClick={() => deleteMarker(k, location)}><i className="cursor-pointer far fa-trash-alt fa-fw text-danger"></i> Delete Marker</span>
                }
            ]

            if ((!bim_streaming_permission || enable_view_streaming === false) || (location && location.location_operstatus === "Disconnected")) {
                items.shift();
            }
            if (!bim_markers_permission) {
                items.pop();
            }
            let select = <Dropdown menu={{ items }}>
                <div>
                    <Tooltip placement="left" overlayInnerStyle={{ width: '258px', backgroundColor: 'transparent', boxShadow: 'none', color: '#333333' }} title={<ZoneCard do_not_navigate={true} zone={location} site={user.site_selected}></ZoneCard>}>
                        <span className="cursor-pointer bg-warning font-size-12 p-1 border-rounded-r">{location ? location.location_name : ""}</span>
                    </Tooltip>
                </div>
            </Dropdown>;

            let cameras_inuse = Object.values(cameras).map(c => c.location_id);
            let cameras_filtered = zones.filter(location => !cameras_inuse.includes(location.location_id));

            //console.log('cameras_inuse, cameras_filtered', [cameras_inuse, cameras_filtered]);

            if (editMode === 'N' && cameras_filtered.length === 0) {
                Toastr.error("All the gateways are already marked.");
                return;
            }

            if (editMode === 'N')
                select = <Select name="location_id" onChange={(obj) => onCameraGatewayChange(obj, k, camera)} style={{ width: '100%' }} placeholder="Choose Gateway location">
                    {cameras_filtered.map(c => <Option key={c.location_id} value={c.location_id}>{c.location_name}</Option>)}
                </Select>

            ReactDOM.render(select, ReactDOM.findDOMNode(document.getElementById(k + "-rem_location_picker")));
        }

        $(d).removeClass("hide");
        $(d).attr('style', 'position: absolute; left:' + (cam_pos.offsetX * $('#procore-bim-main-canvas').width()) + 'px; top:' + (cam_pos.offsetY * $('#procore-bim-main-canvas').height()) + 'px;');

    }

    let fetchZoneHistory = (z) => {
        user.zone_selected = z;
        sessionManager.storeCookie('user', user);
        setShowZoneHistory(true);
    }

    let streamVideo = (z) => {
        user.zone_selected = z;
        sessionManager.storeCookie('user', user);
        setTurnOnVideoStreaming(true);
    }

    let onCameraGatewayChange = (location_id, key, cam) => {
        // console.log('this.cameras', cam);
        //console.log('onCameraGatewayChange', [location_id, key, this.cameras[key]]);
        let oldKey = key.split('O')[0];
        let newKey = oldKey + "O" + location_id;
        console.log(cameras);
        let camera = { ...cam }
        camera[newKey] = JSON.parse(JSON.stringify(camera[key]));
        camera[newKey].location_id = location_id;
        delete camera[key];

        $('#' + key).remove();
        createMarker(camera[newKey], 'O');
        // setCameras(camera);
        cameras = camera;
        setRefreshTimestamp(new Date().getTime());
        setEnableSaveButton(true);
    }

    let deleteMarker = (markerId, location) => {
        console.log('markerId', markerId);
        let camera = { ...cameras };
        delete camera[markerId];
        cameras = camera;
        $('#' + markerId).remove();
        setRefreshTimestamp(new Date().getTime());
        setEnableSaveButton(true);
    }

    let saveBIMMarkers = () => {
        let recs = [];
        for (let c of Object.values(cameras)) {
            if (!c['location_id'] || c['location_id'] === '00000')
                continue;
            recs.push({ bim_id: bim_model.id, bim_type: 'CAMERA', bim_data: JSON.stringify(c) });
        }
        console.log(recs);

        CommonUtils.ajax(
            {
                url: API.BIM.MODIFY_OBJECTS,
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify({
                    user_login: user.user_login,
                    user_token: user.user_token,
                    customer_id: user.customer_id,
                    site_id: user.site_selected.site_id,
                    app_name: 'SITESUPT',
                    bim_id: bim_model.id,
                    form_input: JSON.stringify(recs)
                })
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    setEnableSaveButton(false);
                    Toastr.success("Markers saved successfully");
                    $('.marker').remove();
                    setTimeout(() => {
                        console.log("Markers refreshed successfully");
                        fetchBIMMarkers();
                    }, 5000);
                }
            },
            (res) => {

            });
    }

    let clearBIMMarkers = () => {
        for (let m in cameras)
            if ($('#' + m))
                $('#' + m).remove();

        // setCameras(JSON.parse(JSON.stringify(cameras_original)));
        cameras = JSON.parse(JSON.stringify(cameras_original));
        setEnableSaveButton(false);
        setEnableCancelButton(false);
    }

    let fetchBIMMarkers = () => {
        CommonUtils.ajax(
            {
                url: API.BIM.FETCH_OBJECTS,
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify({
                    user_login: user.user_login,
                    user_token: user.user_token,
                    customer_id: user.customer_id,
                    site_id: user.site_selected.site_id,
                    app_name: 'SITESUPT',
                    bim_id: bim_model.id,
                })
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    let camera = {};
                    if (res.data.length > 0) {
                        for (let x of res.data) {
                            let bim_data = x.bim_data || null;
                            bim_data.id = x.id;

                            if (bim_data) {
                                let pos = bim_data.bcfCamera.perspective_camera.camera_view_point;
                                let k = [parseInt(pos.x), parseInt(pos.y), parseInt(pos.z)].join('-');
                                camera[k + "O" + bim_data.location_id] = bim_data;
                            }
                        }
                    }
                    cameras = camera;
                    setCamerasOriginal(JSON.parse(JSON.stringify(camera)));
                    // setCameras(cameras);
                    setEnableSaveButton(false);
                    setEnableCancelButton(false);
                }
            },
            (res) => {

            });
    }

    let setBCFCamera = (l) => {
        console.log('setBCFCamera', l);
        console.log(viewer);
        if (viewer && viewer.camera && l.bcfCamera) {
            viewer.camera.setBcfCamera(l.bcfCamera);
            setTimeout(() => {
                showMarker(l, 'F');
            }, 100);
        }
    }

    function getActiveZones() {
        let user_allowed_zones = [];
        if (user1.user_zones && user1.user_zones[user1.site_selected.site_id])
            user_allowed_zones = user1.user_zones[user1.site_selected.site_id];

        if (user1.zone_prefs && user1.zone_prefs.length > 0)
            user_allowed_zones.concat(user1.zone_prefs);


        let filteredZones = user1.zones ? user1.zones.filter(zone => {
            // console.log(zone.location_id + " - " + zone.location_name + " - " + zone.location_adminstatus);
            if (zone.location_adminstatus === "Up") {
                if (user_allowed_zones.length > 0) {
                    return user_allowed_zones.includes(zone.location_id);
                } else {
                    return true;
                }
            }
            return false;
        }) : [];

        let zoneProp = 'location_name';
        return filteredZones.sort((a, b) => a[zoneProp] > b[zoneProp] ? 1 : a[zoneProp] < b[zoneProp] ? -1 : 0);
    }

    let cameraLocators = [];
    console.log('CameraLocators recalculating ...')
    console.log(cameras);
    for (let c of Object.values(cameras || {})) {
        if (c.location_id) {
            let x = {};
            let location = zones.find(x => x.location_id === c.location_id);

            x.label = location ? <span>{location.location_name}</span> : "";
            x.key = c.location_id;
            x.bcfCamera = c.bcfCamera;
            x.offsetX = c.offsetX;
            x.offsetY = c.offsetY;
            x.location_id = c.location_id;

            if (x.label !== '')
                cameraLocators.push(x);
        }
    }

    const items = cameraLocators.map(l => {
        let element = <div onClick={() => setBCFCamera(l)} key={l.key}>{l.label.props.children}</div>
        return (
            { key: l.key, label: element }
        )
    });

    return (
        <React.Fragment>

            <div className="page-container p-0">
                <div className="hide">{refresh_timestamp}</div>

                {(!bim_bundles || loading) && <div className="p-3"> <Loading>Opening BIM Model ...</Loading></div>}

                <span style={{ float: "right", paddingRight: "50px" }}>

                    {(enableCancelButton || enableSaveButton) &&
                        <button className="btn btn-sm btn-default mr-2 cancel-btn" onClick={() => clearBIMMarkers()} >Cancel</button>
                    }

                    {enableSaveButton &&
                        <button className="btn btn-sm btn-primary mr-2 save-btn" onClick={() => saveBIMMarkers()} >Save</button>
                    }

                    {!loading &&
                        <Dropdown overlayStyle={{ maxHeight: '300px', overflowY: 'scroll' }} menu={{ items }} placement="bottomRight">
                            <button className="btn btn-warning btn-sm">
                                <img alt="Camera Icon" className="surv-camera" src={camera_icon} width="20px" height="20px" /> &nbsp; <span id="gateway_counter">{cameraLocators.length} Gateways</span>
                            </button>
                        </Dropdown>
                    }
                </span>

                <div id='procore-bim-main' style={{ width: '100%', height: (window.innerHeight - 85) + "px" }}></div>
                {showZoneHistory &&
                    <Modal
                        maskClosable={false}
                        bodyStyle={{ padding: '9px 21px' }}
                        footer={false}
                        width={700}
                        closeIcon={<div style={{ marginTop: "-5px" }}><i className="far fa-lg fa-times-circle text-white"></i></div>}
                        closable
                        open={showZoneHistory}
                        title={user1.zone_selected.location_name}
                        onCancel={() => setShowZoneHistory(false)}>
                        <ZoneHistoryCarousel date={moment.tz(user1.zone_selected.location_dev_timestamp * 1000, timezone).format('YYYY-MM-DD')}></ZoneHistoryCarousel>
                    </Modal>
                }

                {
                    turnOnVideoStreaming &&
                    <Modal
                        bodyStyle={{ padding: '0px' }}
                        footer={false}
                        width={700}
                        closable={false}
                        okButtonProps={{ visibility: 'hidden' }}
                        open={turnOnVideoStreaming}
                        onOk={() => setTurnOnVideoStreaming(false)}>
                        {user1.zone_selected.location_device_type ? <AxisLiveCameraFeed closeModal={() => setTurnOnVideoStreaming(false)} zone={user1.zone_selected} user={user}></AxisLiveCameraFeed> :
                            <LiveCameraFeed closeModal={() => setTurnOnVideoStreaming(false)} zone={user1.zone_selected} user={user}></LiveCameraFeed>
                        }
                    </Modal>
                }
            </div>
        </React.Fragment >
    );
}

export default BIMViewer;